(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-patient-process', {
                parent: 'entity',
                url: '/type-patient-process',
                data: {
                    authorities: [],
                    pageTitle: 'TypePatientProcesses'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-patient-process/list/type-patient-process.html',
                        controller: 'TypePatientProcessController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_PATIENT_PROCESS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PATIENT_PROCESS, access);
                }]
            });
    }
})();
